export enum RequestTypes {
  ORGANISER = 0,
  PUBLISH_EVENT = 1,
  PUBLISH_LEAGUE = 2,
  ADD_EVENT_TO_LEAGUE = 3,
}
